import * as  React from 'react';
import './App.css';
import { SelectionPreview, BubblePreview, InsertionPreview, CombPreview, ShellPreview, 
         CountingPreview, CocktailPreview, GnomePreview, BrickPreview } from './components/Preview/Preview';
import { 
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from 'react-router-dom';

function App() {
  return (
    <Router>
      <div>
        <nav className="nav-bar">
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/bubble">Bubble</Link>
            </li>
            <li>
              <Link to="/selection">Selection</Link>
            </li>
            <li>
              <Link to="/insertion">Insertion</Link>
            </li>
            <li>
              <Link to="/counting">Counting</Link>
            </li>
            <li>
              <Link to="/comb">Comb</Link>
            </li>
            <li>
              <Link to="/shell">Shell</Link>
            </li>
            <li>
              <Link to="/cocktail">Cocktail</Link>
            </li>
            <li>
              <Link to="/gnome">Gnome</Link>
            </li>
            <li>
              <Link to="/brick">Brick</Link>
            </li>
          </ul>
        </nav>

        <Switch>
          <Route path="/bubble">
            <div className="App">
              <header className="App-header">
                <BubblePreview />
              </header>
            </div>
          </Route>
          <Route path="/selection">
            <div className="App">
              <header className="App-header">
                <SelectionPreview />
              </header>
            </div>
          </Route>
          <Route path="/counting">
            <div className="App">
              <header className="App-header">
                <CountingPreview/>
              </header>
            </div>
          </Route>
          <Route path="/insertion">
            <div className="App">
              <header className="App-header">
                <InsertionPreview />
              </header>
            </div>
          </Route>
          <Route path="/shell">
            <div className="App">
              <header className="App-header">
                <ShellPreview />
              </header>
            </div>
          </Route>
          <Route path="/counting">
            <div className="App">
              <header className="App-header">
                <CountingPreview/>
              </header>
            </div>
          </Route>
          <Route path="/comb">
            <div className="App">
              <header className="App-header">
                <CombPreview />
              </header>
            </div>
          </Route>
          <Route path="/cocktail">
            <div className="App">
              <header className="App-header">
                <CocktailPreview/>
              </header>
            </div>
          </Route>
          <Route path="/gnome">
            <div className="App">
              <header className="App-header">
                <GnomePreview/>
              </header>
            </div>
          </Route>
          <Route path="/brick">
            <div className="App">
              <header className="App-header">
                <BrickPreview/>
              </header>
            </div>
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

function Home() {
  return (
    <div className="App-header">
      <h1 className="home-text">Visualisasi<br/>Algoritma</h1>
    </div>
  )
}

export default App;
